var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "width": "76",
      "height": "76",
      "viewBox": "0 0 76 76",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M66.9641 15.0606C67.3742 14.7398 67.4475 14.1463 67.1166 13.7443C63.0496 8.80384 57.7886 4.97519 51.8254 2.62553C45.5695 0.160562 38.7683 -0.587027 32.1264 0.460201C25.4844 1.50743 19.2432 4.31139 14.0493 8.58165C9.09832 12.6521 5.27053 17.9138 2.92099 23.866C2.72981 24.3503 2.98217 24.8924 3.47114 25.0714C3.96011 25.2504 4.50046 24.9986 4.69228 24.5145C6.92581 18.8779 10.5556 13.8952 15.2468 10.0382C20.1811 5.98148 26.1102 3.31772 32.4201 2.32285C38.7299 1.32798 45.191 2.03819 51.1341 4.37992C56.7845 6.60632 61.7713 10.2305 65.6308 14.9064C65.9623 15.308 66.5539 15.3813 66.9641 15.0606Z",
      "fill": "#3FC135"
    }
  }), _c('path', {
    attrs: {
      "d": "M2.65855 27.5624C2.15808 27.4186 1.63462 27.7076 1.50343 28.2115C0.253729 33.0117 -0.0375408 38.0144 0.649852 42.933C1.38077 48.163 3.20193 53.1812 5.9954 57.6627C8.78888 62.1442 12.4924 65.9891 16.8662 68.9484C21.2399 71.9077 26.1865 73.9155 31.3854 74.8417C36.5844 75.7679 41.92 75.5919 47.0466 74.3251C52.1733 73.0584 56.9768 70.729 61.146 67.488C65.3153 64.2469 68.7574 60.1664 71.2495 55.5105C73.5933 51.132 75.0476 46.3364 75.5325 41.4C75.5834 40.8818 75.1919 40.4298 74.6726 40.3919C74.1533 40.354 73.7028 40.7444 73.6512 41.2625C73.186 45.9356 71.8062 50.4749 69.5871 54.6207C67.2196 59.0437 63.9495 62.9202 59.9887 65.9992C56.0279 69.0782 51.4646 71.2911 46.5943 72.4945C41.724 73.698 36.6552 73.8651 31.7162 72.9852C26.7771 72.1053 22.0779 70.198 17.9229 67.3866C13.7678 64.5753 10.2494 60.9227 7.59563 56.6652C4.94183 52.4078 3.21174 47.6405 2.51736 42.672C1.86652 38.0149 2.13921 33.2784 3.31642 28.7322C3.44695 28.2281 3.15903 27.7061 2.65855 27.5624Z",
      "fill": "#3FC135"
    }
  }), _c('path', {
    attrs: {
      "d": "M68.5469 17.2451C68.9795 16.9552 69.5663 17.0704 69.8452 17.5101C73.4007 23.1144 75.4144 29.5584 75.6824 36.19C75.7034 36.7103 75.2866 37.1391 74.7659 37.1471C74.2453 37.1551 73.818 36.7393 73.7963 36.2191C73.5348 29.9513 71.6318 23.8616 68.2782 18.5601C67.9998 18.12 68.1143 17.5349 68.5469 17.2451Z",
      "fill": "#3FC135"
    }
  }), _c('path', {
    attrs: {
      "d": "M14.6755 31.4235L32.4962 52.9132L61.3235 22.5132",
      "stroke": "#3FC135",
      "stroke-width": "10"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }